import { Service } from '@angular/core';
import { PageDataServiceBase, PageState, PageStateBase, PageStateService } from '@portal-core/data/page/services/page.state';
import { TranslationPackageLanguageBranch } from '@portal-core/translation-package-language-branches/models/translation-package-language-branch.model';
import { TranslationPackageLanguageBranchesState } from '@portal-core/translation-package-language-branches/services/translation-package-language-branches-data.service';
import { TranslationPackage } from '@portal-core/translation-packages/models/translation-package.model';
import { TranslationPackagesState } from '@portal-core/translation-packages/services/translation-packages-data.service';


@PageState({
  name: 'projectTranslationPageState',
  actionName: 'ProjectTranslationPage'
})
export class ProjectTranslationPageState extends PageStateBase { }

@Service()
@PageStateService<TranslationPackage, TranslationPackageLanguageBranch>({
  pageState: ProjectTranslationPageState,
  itemCollectionState: TranslationPackagesState,
  subItemCollectionState: TranslationPackageLanguageBranchesState
})
export class ProjectTranslationPageDataService extends PageDataServiceBase<TranslationPackage, TranslationPackageLanguageBranch> {
  override state = ProjectTranslationPageState;
}
